import ChecmarkSquareIcon from 'public/icons/checkmark-square.svg'
import DuelIcon from 'public/icons/challenges.svg'
import SimulationIcon from 'public/icons/material.svg'

import { Sliders } from 'lucide-react'

export interface subCategoryFormat {
    label: string
    tabs: string[]
}

export interface PageFormat {
    name: string
    path: string
    subCategories: subCategoryFormat[]
    icon: React.ElementType
}

export const allPages: Record<string, PageFormat> = {
    // home: {
    //     name: 'Home',
    //     path: '',
    //     labels: ['Nuovo', 'Conclusi', 'Statistiche'],
    //     labelPath: ['exercise', 'concluded', 'stats'],
    //     icon: HomeIcon,
    // },
    quiz: {
        name: 'Quiz',
        path: 'quiz',
        subCategories: [
            { label: 'exercise', tabs: ['homepage', 'suspended'] },
            { label: 'concluded', tabs: ['all'] },
            { label: 'stats', tabs: ['stats'] },
        ],
        icon: ChecmarkSquareIcon,
    },
    duels: {
        name: 'Sfide',
        path: 'duels',
        subCategories: [
            { label: 'competition', tabs: ['homepage', 'invites', 'pending', 'concluded'] },
            { label: 'ranking', tabs: ['rank'] },
        ],
        icon: DuelIcon,
    },
    simulations: {
        name: 'Simulazioni',
        path: 'simulations',
        subCategories: [
            { label: 'exercise', tabs: ['homepage', 'proposed', 'incoming', 'suspended'] },
            { label: 'concluded', tabs: ['homepage', 'classic', 'flex'] },
            { label: 'stats', tabs: ['stats'] },
        ],
        icon: SimulationIcon,
    },
    theory: {
        name: 'Teoria',
        path: 'theory',
        subCategories: [{ label: 'lessons', tabs: ['learn', 'subjects', 'arguments'] }],
        icon: SimulationIcon,
    },
    settings: {
        name: 'Impostazioni',
        path: 'settings',
        subCategories: [
            { label: 'edit-profile', tabs: ['edit'] },
            { label: 'exams-settings', tabs: ['exam'] },
            { label: 'notifications', tabs: ['notifications'] },
        ],
        icon: Sliders,
    },
}
